import { useState } from "react";
import { BookOpen, ClipboardCheck, Archive } from "lucide-react";
import AdminUATDocs from "./AdminUAT";
import AdminUATCycles from "./AdminUATCycles";
import AdminReleaseHistory from "./AdminReleaseHistory";
import "./AdminUATCycles.css";

/**
 * Shell for the /admin/uat route.
 * Provides the three top-level tabs — Docs (read the UAT package),
 * Cycles (execute UAT with per-test tracking + sign-off), and
 * Release History (immutable archive of every signed-off release).
 */
const VALID_TABS = new Set(["docs", "cycles", "history"]);

export default function AdminUATShell() {
  const [tab, setTab] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    const t = p.get("tab");
    return VALID_TABS.has(t) ? t : "docs";
  });

  const setActiveTab = (t) => {
    setTab(t);
    const p = new URLSearchParams(window.location.search);
    p.set("tab", t);
    window.history.replaceState(null, "", `${window.location.pathname}?${p.toString()}`);
  };

  return (
    <div data-testid="admin-uat-shell">
      <div className="hw-uat__tabs no-print" role="tablist">
        <button role="tab" type="button"
                className={`hw-uat__tab${tab === "docs" ? " is-active" : ""}`}
                onClick={() => setActiveTab("docs")}
                data-testid="admin-uat-tab-docs">
          <BookOpen className="w-4 h-4" /> Docs
        </button>
        <button role="tab" type="button"
                className={`hw-uat__tab${tab === "cycles" ? " is-active" : ""}`}
                onClick={() => setActiveTab("cycles")}
                data-testid="admin-uat-tab-cycles">
          <ClipboardCheck className="w-4 h-4" /> UAT Cycles
        </button>
        <button role="tab" type="button"
                className={`hw-uat__tab${tab === "history" ? " is-active" : ""}`}
                onClick={() => setActiveTab("history")}
                data-testid="admin-uat-tab-history">
          <Archive className="w-4 h-4" /> Release History
        </button>
      </div>
      {tab === "docs" && <AdminUATDocs />}
      {tab === "cycles" && <AdminUATCycles />}
      {tab === "history" && <AdminReleaseHistory />}
    </div>
  );
}
